<template>
  <li class="flex items-start gap-3 text-gray-700 text-base">
    <span class="mt-1 text-primary">
      {{ iconToShow }}
    </span>
    <span>{{ text }}</span>
  </li>
</template>

<script setup lang="ts">
const props = defineProps<{
  text: string;
  icon?: string;
}>();

const iconToShow = props.icon || "✔️"; // default to checkmark
</script>
